/**
 * @generated SignedSource<<9779a3525ee86117b722bb17374ba229>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type RegistryAccessLevels = "READ_AND_WRITE" | "READ_ONLY" | "READ_WRITE_AND_ADMIN" | "%future added value";
export type TeamRegistryCreateInput = {|
  accessLevel?: ?RegistryAccessLevels,
  clientMutationId?: ?string,
  registryID: string,
  teamID: string,
|};
export type RegistriesChooserMutation$variables = {|
  input: TeamRegistryCreateInput,
|};
export type RegistriesChooserMutation$data = {|
  +teamRegistryCreate: ?{|
    +clientMutationId: ?string,
    +team: ?{|
      +id: string,
      +registries: ?{|
        +count: number,
      |},
    |},
  |},
|};
export type RegistriesChooserMutation = {|
  response: RegistriesChooserMutation$data,
  variables: RegistriesChooserMutation$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TeamRegistryCreatePayload",
    "kind": "LinkedField",
    "name": "teamRegistryCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamRegistryConnection",
            "kind": "LinkedField",
            "name": "registries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegistriesChooserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegistriesChooserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "67187ee7576ca63f12d0dbb1f3aeec9c",
    "id": null,
    "metadata": {},
    "name": "RegistriesChooserMutation",
    "operationKind": "mutation",
    "text": "mutation RegistriesChooserMutation(\n  $input: TeamRegistryCreateInput!\n) {\n  teamRegistryCreate(input: $input) {\n    clientMutationId\n    team {\n      id\n      registries {\n        count\n      }\n    }\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "1713a75476fb17067cbfca1607dedb96";

module.exports = ((node/*: any*/)/*: Mutation<
  RegistriesChooserMutation$variables,
  RegistriesChooserMutation$data,
>*/);
